import { useState } from "react";
import { wrapperRequests } from "../../../services/api";
import { useAuth } from "../../auth";

interface CreateAutoPrintPayload {
  userId: string;
  tagsToBePrinted: string[];
}

export default function useCreateAutoPrint() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { user } = useAuth();

  const createAutoPrint = async (tagsToBePrinted: string[]) => {
    if (!user?.user?.id) {
      setError("User not authenticated");
      return false;
    }

    setLoading(true);
    setError(null);

    try {
      const payload: CreateAutoPrintPayload = {
        userId: user.user.id,
        tagsToBePrinted,
      };

      await wrapperRequests("printers/autoprint", "POST", {
        data: payload,
      });

      return true;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      console.error("Error creating auto print:", err);
      setError(err?.response?.data?.message || "Error creating auto print");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    createAutoPrint,
    loading,
    error,
  };
}
